import { SimpleFooter } from "@cmsgov/ds-medicare-gov"
import { useEffect } from "react"
import { internalLinkClicked } from "../analytics";
import translate from "../functions/translate"

export const Footer = () => {
    // Add link analytics to footer urls
    useEffect(() => {
        const [footer] = document.getElementsByTagName('footer');
        if (footer) {
            const links = footer.querySelectorAll('a');
            links.forEach(a => {
                const href = a.getAttribute('href');
                const text = a.textContent;
                if (href?.includes('medicare.gov')) {
                    a.onclick = () => {
                        internalLinkClicked({
                            linkUrl: href,
                            linkText: text!,
                            parentComponentHeading: 'footer',
                            parentComponentType: 'footer',
                            siteSection: 'account management'
                        });
                    }
                }
            })
        }
    }, []);

    return <SimpleFooter
        aboutMedicareLabel={translate('about_medicare')}
        linkingPolicyLabel={translate('linking_policy')}
        medicareGlossaryLabel={translate('medicare_glossary')}
        nondiscriminationLabel={translate('nondiscrimination_accessibility')}
        plainWritingLabel={translate('plain_writing')}
        privacyPolicyLabel={translate('privary_policy')}
        privacySettingLabel={translate('privacy_settings')}
        usingThisSiteLabel={translate('using_this_site')}
        websiteInfo={translate('federal_government_website')}
    />
}